import BeforeAfterSlider from "../../components/cards/before-after";
import { SiteHeader } from "../../components/header/header";

import "../../styles/services.css";

import { cleaningServiceData, cleaningTypes } from "../../helpers/cleaning-services-data";
import { ServiceUnitCard } from "../../components/cards/service-unit";

export const ServicesPage = () => {
    return (
        <div
            className="flx-col"
        >
            <SiteHeader title={"Services"} />
            <div style={{ height: 100 }} />
            <div className="page-caption">Warum Kunden uns wählen</div>

            <div className="services-container flx-rw wrp">
                {cleaningServiceData.map((service, id) => {
                    return (
                        <ServiceUnitCard cardData={service} key={id} />
                    )
                })}

            </div>
            <div className="page-caption">Unsere Leistungen sprechen für sich.</div>
            <div className="flx-rw wrp services-box">
                {cleaningTypes.map((cleaning, indx) => (
                    <div className="before-after-service" key={indx}>
                        <div className="flx-col c-al">
                            <div className="cleaning-type">{cleaning.label}</div>
                            <div className="city-label">{cleaning.city}</div>
                        </div>
                        <BeforeAfterSlider
                            beforeImage={cleaning.image1}
                            afterImage={cleaning.image2}
                        />
                    </div>
                ))}
                
            </div>

        </div>
    )
}